export class Dashboards {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dashboards",
            "baseName": "dashboards",
            "type": "Array<Dashboard>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Dashboards.attributeTypeMap;
    }
    constructor() {
    }
}
